<template>
  <div class="container">
    <h1>Order Details</h1>
    <order-details
      v-if="order"
      :order="order"
    />
    <br>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { OrderDetails } from '@/components/orders';

export default {
  name: 'OrderDetails',
  components: {
    'order-details': OrderDetails,
  },
  data() {
    return {
      order: null,
    };
  },
  async mounted() {
    const order = await this.getOrderById(this.$route.params.id);
    this.order = order;
  },
  methods: {
    ...mapActions(['getOrderById', 'openTransactions']),
  },

};
</script>



// WEBPACK FOOTER //
// src/views/orders/OrderDetails.vue